import { DateBox, DropDownBox, List, RadioGroup, SelectBox } from 'devextreme-react';
import DataGrid, { Column, FilterRow, Lookup, Scrolling, Selection, Sorting, Summary, TotalItem } from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';
import { TagBox } from 'devextreme-react/tag-box';
import { Tooltip } from 'devextreme-react/tooltip';
import _ from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Card, Col, Collapse, FormGroup, Label, Row } from 'reactstrap';
import { useAuth } from '../../auth';
import Breadcrumb from '../../components/common/breadcrumb';
import api from '../../services/api-configuration';
import { getAllWarehouses } from '../../services/apis';
import { getTaseron } from '../../services/getTaseron';
import useFormatMessage from '../../utils/useFormatMessage';

const WarehouseTransfers = () => {
    const { t } = useFormatMessage();

    const { hasRole } = useAuth(13);

    const [selectedDataSevkiyat, setSelectedDataSevkiyat] = useState([]);
    const mainGridRef = useRef(null);
    const [warehouseCounts, setWarehouseCounts] = useState([]);
    const [data, setData] = useState([]);
    const [filterVisible, setFilterVisible] = useState(true);
    const [selectedData, setSelectedData] = useState([]);
    const [mainData, setMainData] = useState([]);
    const [selectedDestination, setSelectedDestination] = useState(null);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [minHeight, setMinHeight] = useState('calc(100vh - 200px)');
    const [warehouses, setWarehouses] = useState([]);
    const [brand, setBrand] = useState([]);
    const [peron, setPeron] = useState([]);
    const [kontratSahibi, setKontratSahibi] = useState([]);
    const [taseronFirma, setTaseronFirma] = useState([]);
    const [sevkiyatTipi, setSevkiyatTipi] = useState([]);
    // Selected values
    const [selectedWarehouse, setSelectedWarehouse] = useState(null);
    const [selectedToWarehouse, setSelectedToWarehouse] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedSubContractor, setSelectedSubContractor] = useState(null);
    const [popupVisible, setPopupVisible] = useState(false);
    const [groupageMode, setGroupageMode] = useState(null);
    const peronRef = useRef(null);
    const taseronFirmaRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);

    // Format loading_dock value
    const formatLoadingDock = useCallback((loadingDock) => {
        if (!loadingDock) return '';
        const parsedValue = parseInt(loadingDock);
        if (!isNaN(parsedValue)) {
            return `PP-${parsedValue}`;
        }
        return loadingDock;
    }, []);

    const getPeron = useCallback(_.debounce(async (value) => {
        if (!value) return;

        try {
            const response = await api.post("getPeronsByWarehouses", {
                warehouse_ids: [parseInt(value)]
            });
            const all_data = response.data.data || [];

            // Sort only by numeric part after "-"
            all_data.sort((a, b) => {
                const getNumericPart = (addressCode) => {
                    const parts = addressCode.split('-');
                    if (parts.length >= 2) {
                        const numericPart = parseInt(parts[1], 10);
                        return isNaN(numericPart) ? 0 : numericPart;
                    }
                    return 0;
                };

                const numA = getNumericPart(a.address_code);
                const numB = getNumericPart(b.address_code);

                return numA - numB;
            });

            setPeron(all_data); // setPeron olarak düzeltildi

            if (all_data?.length === 0) {
                toast.error("Peron bulunamadı. Lütfen seçili depo için peron ve adres tanımlayın.", {
                    autoClose: 10000
                });
            }
        } catch (error) {
            toast.error("Hata oluştu");
            console.error("Error fetching route:", error);
        }
    }, 300), []);

    // Fetch initial data
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                // Style header
                document.querySelector(".page-main-header").classList.add('open');
                document.querySelector(".page-sidebar").classList.add('open');

                // Fetch warehouses
                const warehousesRes = await getAllWarehouses();
                setWarehouses(warehousesRes);

                // Fetch brands
                const brandsRes = await api.post("/getAllBrands");
                setBrand(brandsRes.data.data || []);
                // Fetch sevkiyat tipi
                getSevkiyatTipi();

                // Fetch contractors
                const contractorsRes = await getTaseron({ contract_owner: true });
                setKontratSahibi(contractorsRes);

                // Fetch subcontractors
                const subcontractorsRes = await getTaseron({ transport_company: true });
                setTaseronFirma(subcontractorsRes);

                calculateHeight();
            } catch (error) {
                console.error("Error fetching initial data:", error);
                toast.error("Veri yüklenirken hata oluştu");
            }
        };

        fetchInitialData();

        window.addEventListener('resize', calculateHeight);
        return () => window.removeEventListener('resize', calculateHeight);
    }, []);

    const getSevkiyatTipi = async () => {
        try {
            const response = await api.post("/shippingType/getAll");
            let all_data = response.data.data || [];
            setSevkiyatTipi(
                all_data.filter(item => item.is_active && item.id !== 2 && item.id !== 5 && item.id !== 6)
            );
        } catch (error) {
            console.error(error);
            toast.error("Hata oluştu");
        }

    }
    const calculateHeight = () => {
        const headerHeight = document.querySelector('.page-main-header')?.offsetHeight || 0;
        const breadcrumbHeight = document.querySelector('.breadcrumb')?.offsetHeight || 0;
        const filterCardHeight = document.querySelector('.card')?.offsetHeight || 0;
        const padding = 48;
        setMinHeight(`calc(100vh - ${headerHeight + breadcrumbHeight + filterCardHeight + padding}px)`);
    };

    const handleSearch = async () => {
        setSelectedData([]);
        const warehouse_ids = [];
        const brand_codes = [];
        const nereden = []
        const nereye = []

        if (document.getElementById("warehouse-select")) {
            let selected = document.getElementById("warehouse-select").childNodes[0].childNodes[0].childNodes;
            selected.forEach((item) => {
                warehouse_ids.push(parseInt(item.value));
            });
        }

        if (document.getElementById("brand-select")) {
            let selected = document.getElementById("brand-select").childNodes[0].childNodes[0].childNodes;
            selected.forEach((item) => {
                brand_codes.push(item.value);
            });
        }
        if (document.getElementById("province-select")) {
            let selected = document.getElementById("province-select").childNodes[0].childNodes[0].childNodes;
            selected.forEach((item) => {
                nereye.push(parseInt(item.value));
            });
        }
        if (document.getElementById("dealer-select")) {
            let selected = document.getElementById("dealer-select").childNodes[0].childNodes[0].childNodes;
            selected.forEach((item) => {
                nereden.push(parseInt(item.value));
            });
        }

        const body = {
            "brand": brand_codes.length ? brand_codes : null,
            "customs_clearance": document.getElementById("gumruk-select").childNodes[0].value === "" ? null : document.getElementById("gumruk-select").childNodes[0].value === "1" ? true : false,
            "from_warehouse_id": warehouse_ids.length ? warehouse_ids : null,
            "pdi_exit": document.getElementById("pdi-select").childNodes[0].value === "1" ? true : null,
            "to_warehouse_id": nereye.length ? nereye : warehouses.map(item => item.id),
            "true_warehouse_id": nereden.length ? nereden : null
        };

        try {
            const response = await api.post("/getEligibleTransfers", body);
            let allData = response.data.data || [];

            if (allData.length === 0) {
                toast.warning("Veri bulunamadı");
                setMainData([]);
            }

            setData(allData);
            updateWarehouseCounts(allData);
            setIsDataLoaded(true);
        } catch (error) {
            console.error(error);
            toast.error("Hata oluştu");
        }
    };

    const updateWarehouseCounts = (data) => {
        const counts = data.reduce((acc, curr) => {
            const warehouseKey = curr.to_warehouse;

            if (!acc[warehouseKey]) {
                acc[warehouseKey] = {
                    warehouse: warehouseKey,
                    count: 0,
                    vehicles: []
                };
            }

            acc[warehouseKey].count += 1;
            acc[warehouseKey].vehicles.push(curr);

            return acc;
        }, {});

        setWarehouseCounts(Object.values(counts));
        setMainData(selectedDestination ?
            data.filter(item => item.to_warehouse === selectedDestination) :
            data
        );
    };

    const handleMainGridSelection = (e) => {
        const selectedRows = e.selectedRowsData;
        if (selectedRows?.length === 0) return;

        // İlk seçilen aracın customs_cleared değerini referans al
        const firstItemClearedStatus = selectedRows[0].customs_cleared;

        // Tüm seçili araçların aynı customs_cleared değerine sahip olup olmadığını kontrol et

        const hasInconsistentStatus = selectedData.some(
            row => row.customs_cleared !== firstItemClearedStatus
        );

        let t_sevkiyatTipi = sevkiyatTipi
        if (firstItemClearedStatus === true) {
            t_sevkiyatTipi = sevkiyatTipi.filter(item => item.id === 5 || item.id === 4)
        } else if (firstItemClearedStatus === false) {
            t_sevkiyatTipi = sevkiyatTipi.filter(item => item.id === 6 || item.id === 7)
        }
        setSelectedDataSevkiyat(t_sevkiyatTipi)

        if (hasInconsistentStatus) {
            toast.error("Gümrük durumu farklı olan araçları birlikte seçemezsiniz!");
            e.component.deselectAll(); // Seçimi temizle
            return;
        }

        // Orijinal işlemlere devam et
        let selectedWarehouseName = selectedRows[0].from_warehouse;
        if (selectedWarehouse === null) {
            setSelectedWarehouse(
                warehouses.find(w => w.warehouse_name === selectedWarehouseName)?.id
            );
            getPeron(
                warehouses.find(w => w.warehouse_name === selectedWarehouseName)?.id
            )
        }

        setSelectedData([...selectedData, ...selectedRows]);
        setMainData(mainData.filter(
            item => !selectedRows.some(selected => selected.chassis_no === item.chassis_no)
        ));
    };
    const handleSelectedGridSelection = (e) => {
        const selectedRows = e.selectedRowsData;
        setMainData([...mainData, ...selectedRows]);
        setSelectedData(selectedData.filter(
            item => !selectedRows.some(selected => selected.chassis_no === item.chassis_no)
        ));
    };

    const handleWarehouseClick = (e) => {
        const clickedWarehouse = e.data.warehouse;
        setSelectedDestination(
            selectedDestination === clickedWarehouse ? null : clickedWarehouse
        );
    };

    const handleSubContractorChange = (e) => {
        setSelectedSubContractor(taseronFirma.find(t => t.id === e)?.name || '');
    };
    const validatePP999 = (selectedData, peron, selectedPeronId) => {
        // Check if vehicles are from different warehouses
        const warehouses = [...new Set(selectedData.map(item => item.true_warehouse))];
        if (warehouses.length > 1) {
            const pp999Peron = peron.find(p => p.address_code === "PP-999");

            if (!pp999Peron) {
                return {
                    isValid: false,
                    message: "Farklı depolardan transfer yaparken PP-999 peronu seçilmelidir. Seçili depoda PP-999 adresi tanımlanmamış. Lütfen tanımlayınız.",
                    requiredAction: "CREATE_PP999"
                };
            }

            if (selectedPeronId !== pp999Peron.address_id) {
                return {
                    isValid: false,
                    message: "Farklı depolardan transfer yaparken PP-999 peronu kullanılmalıdır.",
                    requiredAction: "SELECT_PP999"
                };
            }
        }

        return {
            isValid: true,
            message: "",
            requiredAction: null
        };
    };
    const validationCheck = () => {
        if (selectedData?.length === 0) {
            toast.error("Seçili araç bulunmamaktadır!");
            return false;
        }
        if (!selectedWarehouse) {
            toast.error("Nereden (Depo) seçiniz!");
            return false;
        }
        if (!selectedToWarehouse) {
            toast.error("Nereye (Depo) seçiniz!");
            return false;
        }
        const selectedPeronId = document.getElementById("peron-select")?.childNodes[0]?.childNodes[0]?.value;
        if (document.getElementById("peron-select").childNodes[0].childNodes[0].value === "") {
            toast.error("Peron seçiniz!");
            return false;
        }

        let selected = peron.find(p => p.address_id === parseInt(selectedPeronId))
        let cp = selected?.capacity - (selected?.used_capacity + selected?.reserved_capacity);

        if (cp < selectedData?.length) {
            toast.error("Peron kapasitesi yetersiz");
            return false
        }

        // const pp999Validation = validatePP999(selectedData, peron, Number(selectedPeronId));
        // if (!pp999Validation.isValid) {
        //     toast.error(pp999Validation.message, { autoClose: 12000 });
        //     return false;
        // }
        if (document.getElementById("date-select").childNodes[0].childNodes[0].value === "") {
            toast.error("Transfer tarihini seçiniz!");
            return false;
        }

        if (document.getElementById("sevkiyat-select").childNodes[0].childNodes[0].value === "") {
            toast.error("Sevkiyat Tipi seçiniz!");
            return false;
        }
        return true;
    };
    const [mode, setMode] = useState('');
    const handleCreateTransfer = async () => {
        if (!validationCheck()) return;

        try {
            setIsLoading(true);
            const subContractorValue = document.getElementById("sub-kontrat-select")?.childNodes[0]?.childNodes[0]?.value;
            const body = {
                "address_id": parseInt(document.getElementById("peron-select").childNodes[0].childNodes[0].value),
                "chassis_numbers": _.uniq(selectedData.map(item => item.chassis_no)),
                "contractor_id": parseInt(document.getElementById("kontrat-select").childNodes[0].childNodes[0].value),
                "subcontractor_id": subContractorValue ? parseInt(subContractorValue) : null,
                "from_warehouse_id": selectedWarehouse,
                "shipping_date": moment(selectedDate).format("YYYY-MM-DD"),
                "to_warehouse_id": selectedToWarehouse,
                "groupage_type": mode === 'bulk' ? "MULTIPLE" : "SINGLE",
                "shipping_type_id": parseInt(document.getElementById("sevkiyat-select").childNodes[0].childNodes[0].value),
                "create_user_id": parseInt(Buffer.from(localStorage.getItem('employee_id'), 'base64').toString('ascii'))
            };
            await api.post("/createWarehouseTransfer", body);
            toast.success("Transfer başarıyla oluşturuldu");
            setSelectedData([]);
            setPopupVisible(false);
            handleSearch();
        } catch (error) {
            console.log(error);
            let message = "HATA: " + error?.response?.data?.error || "Transfer oluşturulurken hata oluştu";
            //toast.error("HATA: " + message); 10sn dursun ekranda
            toast.error(message, {
                autoClose: 10000
            });
        } finally {
            setIsLoading(false);
        }
    };

    const onCellPrepared = (e) => {
        if (e.rowType === "data") {
            if (e.column.dataField === "customs_cleared" && e.value === true) {
                e.cellElement.style.background = "#00b500";
                e.cellElement.style.color = "white";
                e.cellElement.style.fontWeight = "bold";
            }
            if (e.column.dataField === "has_pdi_order" && e.value === true) {
                e.cellElement.style.background = "#00b500";
                e.cellElement.style.color = "white";
                e.cellElement.style.fontWeight = "bold";
            }
            if (e.column.dataField === "pdi_completed" && e.value === true) {
                e.cellElement.style.background = "#00b500";
                e.cellElement.style.color = "white";
                e.cellElement.style.fontWeight = "bold";
            }
        }
    };

    const WarehouseSelectionGroup = ({
        onFromWarehouseChange,
        onToWarehouseChange
    }) => {
        return (
            <>
                <FormGroup style={{ marginBottom: 0 }}>
                    <Label style={{ fontSize: '0.85rem', marginBottom: '0.25rem', fontWeight: '500' }}>Nereden</Label>
                    <SelectBox
                        placeholder="Depo Seçiniz"
                        showClearButton={true}
                        value={selectedWarehouse}
                        dataSource={warehouses}
                        displayExpr="warehouse_name"
                        valueExpr="id"
                        searchEnabled={true}
                        onValueChange={onFromWarehouseChange}
                    />
                </FormGroup>

                <FormGroup style={{ marginBottom: 0 }}>
                    <Label style={{ fontSize: '0.85rem', marginBottom: '0.25rem', fontWeight: '500' }}>Nereye</Label>
                    <SelectBox
                        placeholder="Depo Seçiniz"
                        value={selectedToWarehouse}
                        showClearButton={true}
                        dataSource={warehouses}
                        displayExpr="warehouse_name"
                        valueExpr="id"
                        searchEnabled={true}
                        onValueChange={onToWarehouseChange}
                    />
                </FormGroup>
            </>
        );
    };

    return (
        <>
            <Breadcrumb current="Depolar Arası Transfer" />
            <div className="p-3">
                <Card className="mb-3">
                    <div className="p-1">
                        {filterVisible ? (
                            <i
                                className="fa fa-chevron-up float-right cursor-pointer p-1"
                                style={{
                                    cursor: "pointer",
                                    fontSize: "1.1rem",
                                    color: "#3b3b3b"
                                }}
                                onClick={() => setFilterVisible(false)}
                            />
                        ) : (
                            <i
                                className="fa fa-chevron-down float-right cursor-pointer p-1"
                                style={{
                                    cursor: "pointer",
                                    fontSize: "1.1rem",
                                    color: "#3b3b3b"
                                }}
                                onClick={() => setFilterVisible(true)}
                            />
                        )}

                        <Collapse isOpen={filterVisible}>
                            <Row>
                                <Col md="2" className="px-4">
                                    <FormGroup>
                                        <Label>Depo</Label>
                                        <TagBox
                                            placeholder="Depo Seçiniz"
                                            showClearButton={true}
                                            dataSource={warehouses}
                                            displayExpr="warehouse_name"
                                            valueExpr="id"
                                            maxDisplayedTags={3}
                                            id="warehouse-select"
                                            searchEnabled={true}
                                            multiline={true}
                                            showSelectionControls={true}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2" className='p-2'>
                                    <FormGroup>
                                        <Label>Nereden</Label>
                                        <TagBox
                                            placeholder="Bayi Seçebilirsiniz"
                                            showClearButton={true}
                                            dataSource={warehouses}
                                            id='dealer-select'
                                            valueExpr={"id"}
                                            displayExpr="warehouse_name"
                                            maxDisplayedTags={3}
                                            searchEnabled={true}
                                            multiline={true}
                                            showSelectionControls={true}


                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2" className='p-2'>
                                    <FormGroup>
                                        <Label>Nereye</Label>
                                        <TagBox
                                            placeholder="Varış Deposu Seçebilirsiniz"
                                            showClearButton={true}
                                            dataSource={warehouses}
                                            id='province-select'
                                            valueExpr={"id"}
                                            displayExpr="warehouse_name"
                                            maxDisplayedTags={3}
                                            searchEnabled={true}
                                            multiline={true}
                                            showSelectionControls={true}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2" className="p-2">
                                    <FormGroup>
                                        <Label>Marka</Label>
                                        <TagBox
                                            id="brand-select"
                                            placeholder="Marka Seçiniz"
                                            showClearButton={true}
                                            dataSource={brand}
                                            displayExpr="brand_name"
                                            valueExpr="brand_code"
                                            maxDisplayedTags={3}
                                            searchEnabled={true}
                                        />
                                    </FormGroup>
                                </Col>

                                <Col md="1" className="p-2">
                                    <FormGroup>
                                        <Label>PDI Durumu</Label>
                                        <RadioGroup
                                            id="pdi-select"
                                            items={[
                                                { value: 1, text: 'Yapılanlar' },
                                                { value: 0, text: 'Hepsi' },
                                            ]}
                                            valueExpr="value"
                                            displayExpr="text"
                                            defaultValue={0}
                                            layout="vertical"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="1" className='p-2'>
                                    <FormGroup

                                    >
                                        <Label className='w-100'>Gümrüklendi</Label>
                                        <RadioGroup
                                            id='gumruk-select'
                                            items={[
                                                { value: 1, text: 'Evet' },
                                                { value: 0, text: 'Hayır' },
                                                { value: null, text: 'Hepsi' }
                                            ]}

                                            valueExpr={"value"}
                                            displayExpr={"text"}
                                            defaultValue={null}
                                            layout="vertical"
                                        />

                                    </FormGroup>
                                </Col>
                                <Col md="2" className="d-flex align-items-end"
                                    style={{
                                        flexDirection: "column",
                                        justifyContent: "end"
                                    }}
                                >
                                    <Button
                                        color="success"
                                        disabled={warehouses?.length === 0}
                                        onClick={() => {
                                            if (mainGridRef.current) {
                                                mainGridRef.current.instance.clearSorting();
                                            }
                                            handleSearch();
                                        }}
                                    >
                                        <i className="fa fa-list" /> &nbsp;
                                        <span>Listele</span>
                                    </Button>
                                    &emsp;
                                    <Button
                                        onClick={() => {
                                            if (mainGridRef.current) mainGridRef.current.instance.clearSorting()
                                        }}
                                    >
                                        <i className="fa fa-sort"></i> Temizle


                                    </Button>
                                </Col>
                            </Row>
                        </Collapse>
                    </div>
                </Card>

                <Row className="main-content">
                    <Col md="2">
                        <DataGrid
                            dataSource={warehouseCounts}
                            showBorders={true}
                            height="100%"
                            showColumnLines={true}
                            showRowLines={true}
                            hoverStateEnabled={true}
                            rowAlternationEnabled={true}
                        >
                            {/* <MasterDetail
                                enabled={true}
                                component={WarehouseMasterDetail}
                            /> */}
                            <FilterRow visible={true} />
                            <Column
                                dataField="warehouse"
                                caption="Hedef Depo"
                                cellRender={(cellData) => (
                                    <div
                                        onClick={() => handleWarehouseClick(cellData)}
                                        style={{
                                            cursor: 'pointer',
                                            fontWeight: selectedDestination === cellData.value ? 'bold' : 'normal',
                                            color: selectedDestination === cellData.value ? '#007bff' : 'inherit'
                                        }}
                                    >
                                        {cellData.value}
                                    </div>
                                )}
                            />
                            <Column
                                dataField="count"
                                caption="Adet"
                                width={60}
                                alignment="center"
                            />
                            <Summary>
                                <TotalItem column="count" summaryType="sum" />
                            </Summary>
                        </DataGrid>
                    </Col>

                    <Col md="10"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.8rem",
                        }}
                    >
                        <div className="card p-2 m-0">
                            <DataGrid
                                ref={mainGridRef}
                                dataSource={mainData}
                                showBorders={true}
                                height="40vh"
                                onSelectionChanged={handleMainGridSelection}
                                showColumnLines={true}
                                showRowLines={true}
                                hoverStateEnabled={true}
                                style={{ minWidth: "100%" }}
                                onCellPrepared={onCellPrepared}
                                className="data-grid-gray"
                                allowColumnResizing={true}
                            >
                                <Sorting mode="multiple" />
                                <Selection mode="multiple" showCheckBoxesMode="none" />
                                <FilterRow visible={true} />
                                <Scrolling mode="infinite" showScrollbar="always" />

                                <Column alignment="center" dataField="order_date" caption="Tarih" width={140} dataType="datetime" format="dd/MM/yyyy HH:mm" />
                                <Column alignment="center" dataField="order_id" caption="Emir ID" minWidth={85} />
                                <Column alignment="center" dataField="chassis_no" caption="Şase" width={170} />
                                <Column alignment="center" dataField="brand" caption="Model-Renk" minWidth={160}
                                    calculateDisplayValue={(rowData) => {
                                        return `${rowData.model || ""} - ${rowData.color || ""}`;
                                    }}
                                    calculateFilterExpression={(filterValue, selectedFilterOperation) => {
                                        return [
                                            [(data) => {
                                                const displayValue = `${data.model} - ${data.color}`.toLocaleLowerCase('tr-TR');
                                                return displayValue.includes(filterValue.toLocaleLowerCase('tr-TR'));
                                            }]
                                        ];
                                    }}
                                />
                                <Column
                                    alignment='center'
                                    dataField="vehicle_type"
                                    caption="Tip"
                                    width={110}
                                    calculateDisplayValue={(e) => t(e.vehicle_type)}
                                >
                                    <Lookup dataSource={[
                                        { value: "PASSENGER", text: "Binek" },
                                        { value: "COMMERCIAL", text: "Ticari" },
                                        { value: "HEAVY_COMMERCIAL", text: "Ağır Ticari" },
                                    ]} valueExpr="value" displayExpr="text" />
                                </Column>
                                <Column alignment="center" dataField="true_warehouse" caption="Bulunduğu Depo" width={120} />
                                <Column alignment="center" dataField="from_warehouse" caption="Çıkış Depo" width={"auto"} />
                                <Column alignment="center" dataField="to_warehouse" caption="Varış Depo" width={"auto"} />
                                {/* <Column alignment="center" dataField="zone" caption="Bölge" width={"auto"} /> */}
                                <Column alignment="center" dataField="park_address" caption="Park Adresi" width={"auto"} />
                                {/* <Column caption='Milli' dataField='customs_cleared' alignment='center' width={80} dataType='boolean'>
                                    <Lookup dataSource={[{ value: true, name: '1' }, { value: false, name: '0' }]} valueExpr={"value"} displayExpr={"name"} />
                                </Column> */}
                                <Column caption='Grp. Bz' dataField='groupage_canceled' alignment='center' width={80} dataType='boolean'>
                                    <Lookup dataSource={[{ value: true, name: '1' }, { value: false, name: '0' }]} valueExpr={"value"} displayExpr={"name"} />
                                </Column>


                                <Column alignment="center" dataField="customs_cleared" caption="Gümrük" width={80} dataType='boolean'
                                >
                                    <Lookup dataSource={[{ value: true, name: '1' }, { value: false, name: '0' }]} valueExpr={"value"} displayExpr={"name"} />
                                </Column>
                                <Column alignment="center" dataField="has_pdi_order" caption="PDI Emri" dataType="boolean" width={65}
                                    cssClass='datagrid-column-padding-2'
                                    headerCellRender={() => {
                                        return (
                                            <>
                                                PDI
                                                <br />
                                                Emri
                                            </>
                                        )
                                    }}
                                >
                                    <Lookup dataSource={[{ value: true, name: '1' }, { value: false, name: '0' }]}
                                        valueExpr={"value"} displayExpr={"name"}
                                    />
                                </Column>
                                <Column alignment="center" dataField="pdi_completed" caption="PDI" dataType="boolean" width={62} >
                                    <Lookup dataSource={[{ value: true, name: '1' }, { value: false, name: '0' }]} valueExpr={"value"} displayExpr={"name"} /></Column>
                            </DataGrid>
                        </div>

                        <div className="card p-2 m-0">
                            {/* İlk Satır */}
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr 2fr 1fr",
                                    gap: "0.5rem",
                                    alignItems: "end",
                                    zoom: "0.9",
                                    marginBottom: "0.5rem"
                                }}
                            >
                                <WarehouseSelectionGroup
                                    onFromWarehouseChange={(value) => {
                                        setSelectedWarehouse(value);
                                        getPeron(value);
                                    }}
                                    onToWarehouseChange={(value) => setSelectedToWarehouse(value)}
                                />

                                <FormGroup style={{ marginBottom: 0 }}>
                                    <Label style={{ fontSize: '0.85rem', marginBottom: '0.25rem', fontWeight: '500' }}>Peron</Label>
                                    {/* <SelectBox
                                        id="peron-select"
                                        placeholder="Peron Seçiniz"
                                        showClearButton={true}
                                        dataSource={peron}
                                        searchEnabled={true}
                                        displayExpr={(e) => {
                                            if (e) {
                                                return `${e.warehouse_name} | ${e.address_code} | ${t(e.status)} | (${e.used_capacity}/${e.capacity})`;
                                            }
                                        }}
                                        valueExpr="id"
                                    /> */}



                                    <DropDownBox
                                        id='peron-select'
                                        ref={peronRef}
                                        dataSource={peron}
                                        valueExpr={"address_id"}
                                        displayExpr={(e) => {
                                            if (e) {
                                                return `${e.zone_name} | ${e.address_code} | (${e.used_capacity + e.reserved_capacity}/${e.capacity})`
                                            }
                                        }}
                                        contentRender={(comp) => {
                                            return (
                                                <List
                                                    pageLoadMode="scrollBottom"
                                                    searchExpr={['address_code']}
                                                    searchEnabled={true}
                                                    dataSource={peron}
                                                    displayExpr={(item) => (`${item?.zone_name} | ${item?.address_code} | ${item?.reserved_capacity}R / ${item?.used_capacity}K / ${item?.capacity}` + "T")}
                                                    style={{
                                                        minHeight: "250px",
                                                    }}
                                                    id='peron-item-list'
                                                    itemRender={(item) => {
                                                        return (
                                                            <div className="peron-select-grupaj"
                                                                onClick={() => {
                                                                    // Check if vehicles are from different warehouses
                                                                    const warehouses = [...new Set(selectedData.map(item => item.true_warehouse))];
                                                                    if (warehouses.length > 1) {
                                                                        const pp999Peron = peron.find(p => p.address_code === "PP-999");
                                                                        if (pp999Peron) {
                                                                            comp.component.option("value", pp999Peron.address_code);
                                                                            peronRef.current.instance.option("value", pp999Peron.address_id);
                                                                            comp.component.close();
                                                                        } else {
                                                                            toast.error("Farklı depolardan transfer yaparken PP-999 peronu seçilmelidir. Seçili depoda PP-999 adresi tanımlanmamış. Lütfen tanımlayınız.", {
                                                                                autoClose: 12000
                                                                            });
                                                                        }
                                                                        return;
                                                                    }

                                                                    comp.component.option("value", item.address_code);
                                                                    peronRef.current.instance.option("value", item.address_id);
                                                                    comp.component.close();
                                                                }}
                                                                style={{
                                                                    padding: "10px",
                                                                    color: "black",
                                                                    border: "none",
                                                                    backgroundColor: (item.used_capacity + item.reserved_capacity) >= item.capacity ? "#ffa7a7" :
                                                                        (item.used_capacity + item.reserved_capacity) > 0 ? "#ffd486" : "white"
                                                                }}>
                                                                <div>
                                                                    {item?.zone_name} | {item?.address_code} | {item?.reserved_capacity}R | ({item?.reserved_capacity + item?.used_capacity} / {item?.capacity})
                                                                </div>
                                                            </div>
                                                        )
                                                    }}
                                                />
                                            );
                                        }}
                                        placeholder="Peron Seçebilirsiniz"
                                    />

                                </FormGroup>

                                <FormGroup style={{ marginBottom: 0 }}>
                                    <Label style={{ fontSize: '0.85rem', marginBottom: '0.25rem', fontWeight: '500' }}>Transfer Tarihi</Label>
                                    <DateBox
                                        id="date-select"
                                        displayFormat="dd/MM/yyyy"
                                        type="date"
                                        onValueChange={(e) => setSelectedDate(e)}
                                        width="100%"
                                        placeholder="Transfer Tarihi Seçiniz"
                                        showClearButton={true}
                                    />
                                </FormGroup>
                            </div>

                            {/* İkinci Satır */}
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "0.9fr 0.9fr 0.7fr 1fr",
                                    gap: "0.5rem",
                                    alignItems: "end",
                                    zoom: "0.9"
                                }}
                            >
                                <FormGroup style={{ marginBottom: 0 }}>
                                    <Label style={{ fontSize: '0.85rem', marginBottom: '0.25rem', fontWeight: '500' }}>Kontrat Sahibi</Label>
                                    <SelectBox
                                        id="kontrat-select"
                                        placeholder="Kontrat Sahibi"
                                        showClearButton={true}
                                        dataSource={kontratSahibi}
                                        displayExpr="name"
                                        valueExpr="id"
                                        searchEnabled={true}
                                    />
                                </FormGroup>

                                <FormGroup style={{ marginBottom: 0 }}>
                                    <Label style={{ fontSize: '0.85rem', marginBottom: '0.25rem', fontWeight: '500' }}>Taşıyıcı Firma</Label>
                                    <SelectBox
                                        id="sub-kontrat-select"
                                        ref={taseronFirmaRef}
                                        placeholder="Taşıyıcı Firma"
                                        showClearButton={true}
                                        dataSource={taseronFirma}
                                        displayExpr="name"
                                        valueExpr="id"
                                        onValueChange={handleSubContractorChange}
                                        searchEnabled={true}
                                    />
                                </FormGroup>

                                <FormGroup style={{ marginBottom: 0 }}>
                                    <Label style={{ fontSize: '0.85rem', marginBottom: '0.25rem', fontWeight: '500' }}>Sevk. Tipi</Label>
                                    <SelectBox
                                        id="sevkiyat-select"
                                        placeholder="Tip"
                                        showClearButton={true}
                                        dataSource={selectedDataSevkiyat}
                                        displayExpr="type_name"
                                        valueExpr="id"
                                        searchEnabled={true}
                                    />
                                </FormGroup>

                                <FormGroup style={{ marginBottom: 0, display: "flex", flexDirection: "row", gap: "0.5rem", alignItems: "flex-end", justifyContent: "flex-end" }}>
                                    <Button
                                        color="success"
                                        disabled={isLoading}
                                        onClick={() => {
                                            setMode('bulk');
                                            if (validationCheck()) {
                                                setPopupVisible(true);
                                            }
                                        }}
                                        style={{ minWidth: "40px", padding: "0.375rem 0.5rem", flexShrink: 0 }}
                                    >
                                        <i className="fa fa-save"></i>
                                    </Button>
                                    <Button
                                        color="warning"
                                        disabled={isLoading}
                                        onClick={() => {
                                            setMode('single');
                                            if (validationCheck()) {
                                                setPopupVisible(true);
                                            }
                                        }}
                                        style={{ minWidth: "40px", padding: "0.375rem 0.5rem", flexShrink: 0 }}
                                    >
                                        <i className="fa fa-plus"></i>
                                    </Button>
                                </FormGroup>
                            </div>

                            <DataGrid
                                className="mt-3 data-grid-gray"
                                dataSource={selectedData}
                                showBorders={true}
                                height="30vh"
                                onSelectionChanged={handleSelectedGridSelection}
                                hoverStateEnabled={true}
                                showColumnLines={true}
                                showRowLines={true}
                                onCellPrepared={onCellPrepared}
                                rowAlternationEnabled={true}
                            >
                                <Selection mode="multiple" showCheckBoxesMode="none" />
                                <FilterRow visible={false} />
                                <Scrolling mode="infinite" showScrollbar="always" />

                                <Column alignment="center" dataField="order_date" caption="Tarih" width={140} dataType="datetime" format="dd/MM/yyyy HH:mm" />
                                <Column alignment="center" dataField="order_id" caption="Emir ID" width={"auto"} />
                                <Column
                                    alignment="center"
                                    dataField="chassis_no"
                                    caption="Şase"
                                    width={170}
                                    cellRender={(data) => {
                                        const safeId = data.data.chassis_no?.replace(/[^a-zA-Z0-9]/g, '_') || 'unknown';
                                        const tooltipId = `chassis-tooltip-transfer-${safeId}`;
                                        const loadingDock = formatLoadingDock(data.data.loading_dock);
                                        return (
                                            <>
                                                <span id={tooltipId} style={{ cursor: loadingDock ? 'pointer' : 'default' }}>
                                                    {data.value}
                                                </span>
                                                {loadingDock && (
                                                    <Tooltip
                                                        target={`#${tooltipId}`}
                                                        showEvent="mouseenter"
                                                        hideEvent="mouseleave"
                                                        position={{
                                                            of: `#${tooltipId}`,
                                                            my: 'bottom',
                                                            at: 'top'
                                                        }}
                                                    >
                                                        <div style={{ padding: "5px" }}>
                                                            <strong>Peron:</strong> {loadingDock}
                                                        </div>
                                                    </Tooltip>
                                                )}
                                            </>
                                        );
                                    }}
                                />
                                <Column alignment="center" dataField="brand" caption="Marka" width={100} />
                                <Column alignment="center" dataField="brand" caption="Model-Renk" minWidth={160}
                                    calculateDisplayValue={(rowData) => {
                                        return `${rowData.model || ""} - ${rowData.color || ""}`;
                                    }}
                                    calculateFilterExpression={(filterValue, selectedFilterOperation) => {
                                        return [
                                            [(data) => {
                                                const displayValue = `${data.model} - ${data.color}`.toLocaleLowerCase('tr-TR');
                                                return displayValue.includes(filterValue.toLocaleLowerCase('tr-TR'));
                                            }]
                                        ];
                                    }}
                                />
                                <Column
                                    alignment='center'
                                    dataField="vehicle_type"
                                    caption="Tip"
                                    width={110}
                                    calculateDisplayValue={(e) => t(e.vehicle_type)}
                                >
                                    <Lookup dataSource={[
                                        { value: "PASSENGER", text: "Binek" },
                                        { value: "COMMERCIAL", text: "Ticari" },
                                        { value: "HEAVY_COMMERCIAL", text: "Ağır Ticari" },
                                    ]} valueExpr="value" displayExpr="text" />
                                </Column>
                                <Column alignment="center" dataField="true_warehouse" caption="Bulunduğu Depo" width={120} />
                                <Column alignment="center" dataField="from_warehouse" caption="Çıkış Depo" width={"auto"} />
                                <Column alignment="center" dataField="to_warehouse" caption="Varış Depo" width={"auto"} />
                                {/* <Column alignment="center" dataField="zone" caption="Bölge" width={"auto"} /> */}
                                <Column alignment="center" dataField="park_address" caption="Park Adresi" width={"auto"} />
                                {/* <Column caption='milli' dataField='customs_cleared' alignment='center' width={80} dataType='boolean'>
                                    <Lookup dataSource={[{ value: true, name: '1' }, { value: false, name: '0' }]} valueExpr={"value"} displayExpr={"name"} />
                                </Column> */}
                                <Column alignment="center" dataField="customs_cleared" caption="Gümrük" width={80} dataType='boolean'
                                >
                                    <Lookup dataSource={[{ value: true, name: '1' }, { value: false, name: '0' }]} valueExpr={"value"} displayExpr={"name"} />
                                </Column>
                                {/* <Column alignment="center" dataField="has_pdi_order" caption="PDI Emri" dataType="boolean" width={80} >
                                    <Lookup dataSource={[{ value: true, name: '1' }, { value: false, name: '0' }]}
                                        valueExpr={"value"} displayExpr={"name"}
                                    />
                                </Column>
                                <Column alignment="center" dataField="pdi_completed" caption="PDI OK" dataType="boolean" width={70} >
                                    <Lookup dataSource={[{ value: true, name: '1' }, { value: false, name: '0' }]} valueExpr={"value"} displayExpr={"name"} /></Column> */}

                                <Summary>
                                    <TotalItem
                                        column="chassis_no"
                                        summaryType="count"
                                        displayFormat="{0} araç seçili"
                                    />
                                </Summary>
                            </DataGrid>
                        </div>
                    </Col>
                </Row>

                <Popup
                    visible={popupVisible}
                    onHiding={() => setPopupVisible(false)}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showTitle={true}
                    title="Transfer Onayı"
                    width={800}
                    height={600}
                >
                    <div className="p-2">
                        <div className="mb-4">
                            <table className="table table-bordered mt-2">
                                <tbody>
                                    <tr>
                                        <td style={{ borderColor: "#ddd" }} width="25%">
                                            <strong>Nereden:</strong>
                                        </td>
                                        <td style={{ borderColor: "#ddd" }} width="25%">
                                            {warehouses && warehouses.find(w => w.id === selectedWarehouse)?.warehouse_name}
                                        </td>
                                        <td style={{ borderColor: "#ddd" }} width="25%">
                                            <strong>Nereye:</strong>
                                        </td>
                                        <td style={{ borderColor: "#ddd" }} width="25%">
                                            {warehouses && warehouses.find(w => w.id === selectedToWarehouse)?.warehouse_name}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ borderColor: "#ddd" }}>
                                            <strong>Transfer Tarihi:</strong>
                                        </td>
                                        <td style={{ borderColor: "#ddd" }}>
                                            {selectedDate ? moment(selectedDate).format('DD/MM/YYYY') : '-'}
                                        </td>
                                        <td style={{ borderColor: "#ddd" }}>
                                            <strong>Araç Sayısı:</strong>
                                        </td>
                                        <td style={{ borderColor: "#ddd" }}>
                                            {selectedData.length}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="mb-4">
                            <DataGrid
                                dataSource={selectedData}
                                showBorders={true}
                                showRowLines={true}
                                showColumnLines={true}
                                className="data-grid-gray"
                            >
                                <Column alignment="center" dataField="chassis_no" caption="Şase" />
                                <Column alignment="center" dataField="brand" caption="Marka" />
                                <Column alignment="center" dataField="true_warehouse" caption="Blunduğu Depo" width={120} />
                                <Column alignment="center" dataField="from_warehouse" caption="Çıkış Depo" width={"auto"} />
                                <Column alignment="center" dataField="to_warehouse" caption="Varış Depo" width={"auto"} />
                                <Column alignment="center" dataField="park_address" caption="Park Adresi" />
                            </DataGrid>
                        </div>

                        <div className="d-flex justify-content-end mt-4">
                            <Button
                                color="secondary"
                                disabled={isLoading}
                                onClick={() => setPopupVisible(false)}
                                className="mr-2"
                            >
                                İptal
                            </Button>
                            <Button
                                color="success"
                                disabled={isLoading}
                                onClick={handleCreateTransfer}
                            >
                                {isLoading ? 'İşleniyor...' : 'Transfer Oluştur'}
                            </Button>
                        </div>
                    </div>
                </Popup>
            </div>
        </>
    );
};

export default WarehouseTransfers;